import AppHeader from "@saleor/components/AppHeader";
import CardSpacer from "@saleor/components/CardSpacer";
import Container from "@saleor/components/Container";
import LanguageSwitch from "@saleor/components/LanguageSwitch";
import PageHeader from "@saleor/components/PageHeader";
import { ShopTranslationFragment } from "@saleor/fragments/types/ShopTranslationFragment";
import { commonMessages, sectionNames } from "@saleor/intl";
import { TranslationsEntitiesPageProps } from "@saleor/translations/types";
import React from "react";
import { useIntl } from "react-intl";

import { maybe } from "../../../misc";
import { LanguageCodeEnum } from "../../../types/globalTypes";
import TranslationFields from "../TranslationFields";

export interface TranslationsShopPageProps
  extends TranslationsEntitiesPageProps {
  shop: ShopTranslationFragment;
}

export const fieldNames = {
  headerText: "headerText",
  description: "description",
  keywords: "keywords",
  title: "title"
};

const TranslationsShopPage: React.FC<TranslationsShopPageProps> = ({
  activeField,
  disabled,
  languageCode,
  languages,
  shop,
  saveButtonState,
  onBack,
  onDiscard,
  onEdit,
  onLanguageChange,
  onSubmit
}) => {
  const intl = useIntl();

  return (
    <Container>
      <AppHeader onBack={onBack}>
        {intl.formatMessage(sectionNames.translations)}
      </AppHeader>
      <PageHeader
        title={intl.formatMessage(
          {
            defaultMessage: 'Translation Shop "{pageName}" - {languageCode}',
            description: "header"
          },
          {
            languageCode,
            pageName: maybe(() => shop.headerText, "...")
          }
        )}
      >
        <LanguageSwitch
          currentLanguage={LanguageCodeEnum[languageCode]}
          languages={languages}
          onLanguageChange={onLanguageChange}
        />
      </PageHeader>
      <TranslationFields
        activeField={activeField}
        disabled={disabled}
        initialState={true}
        title={intl.formatMessage(commonMessages.generalInformations)}
        fields={[
          {
            displayName: intl.formatMessage({
              defaultMessage: "Shop headerText"
            }),
            name: fieldNames.headerText,
            translation: maybe(() =>
            shop.translation ? shop.translation.headerText : null
            ),
            type: "short" as "short",
            value: maybe(() => shop.headerText)
          },
          
        ]}
        saveButtonState={saveButtonState}
        onEdit={onEdit}
        onDiscard={onDiscard}
        onSubmit={onSubmit}
      />
      <CardSpacer />
      <TranslationFields
        activeField={activeField}
        disabled={disabled}
        initialState={true}
        title={intl.formatMessage({
          defaultMessage: "Search Engine Preview"
        })}
        fields={[
          
          {
            displayName: intl.formatMessage({
              defaultMessage: "Search Engine Title"
            }),
            name: fieldNames.title,
            translation: maybe(() =>
            shop.translation ? shop.translation.title : null
            ),
            type: "long" as "long",
            value: maybe(() => shop.title)
          },
          {
            displayName: intl.formatMessage({
              defaultMessage: "Search Engine Keywords"
             
            }),
            name: fieldNames.keywords,
            translation: maybe(() =>
            shop.translation ? shop.translation.keywords : null
            ),
            type: "long" as "long",
            value: maybe(() => shop.keywords)
          },
          {
            displayName: intl.formatMessage({
              defaultMessage: "Search Engine Description"
            }),
            name: fieldNames.description,
            translation: maybe(() =>
            shop.translation ? shop.translation.description : null
            ),
            type: "long" as "long",
            value: maybe(() => shop.description)
          }
        ]}
        saveButtonState={saveButtonState}
        onEdit={onEdit}
        onDiscard={onDiscard}
        onSubmit={onSubmit}
      /> 
    </Container>
  );
};
TranslationsShopPage.displayName = "TranslationsShopPage";
export default TranslationsShopPage;
